import React from 'react'
import styled from 'styled-components'
import { DefaultToast } from 'react-toast-notifications'

const Wrapper = styled.div`
  a {
    color: inherit;
    text-decoration: underline;
  }

  .react-toast-notifications__toast {
    color: white;
    background-color: ${({ theme }) => theme.colors.success};
    border-radius: 2px;
  }

  .react-toast-notifications__toast__icon-wrapper {
    display: none;
  }
  .react-toast-notifications__toast__content {
  }

  ${({ appearance, theme }) =>
    (appearance === 'warning' || appearance === 'alert') &&
    `
    .react-toast-notifications__toast {
      color: #333;
      background-color: ${theme.brand.sunup};
    }
  `}

  ${({ appearance, theme }) =>
    appearance === 'error' &&
    `
    .react-toast-notifications__toast {
      background-color: ${theme.colors.errorRed};
    }
  `}
`

const Toast = ({ appearance, children, ...props }) => (
  <Wrapper appearance={appearance}>
    <DefaultToast appearance="success" {...props}>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: children }} />
    </DefaultToast>
  </Wrapper>
)

export default Toast
